import styled from "styled-components";
import {
  getBorderRadius,
  getColor,
  getFadeInAnimation,
  getSize,
  responsive,
} from "~/helpers/style";

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  ${getFadeInAnimation(0.25)}
`;

export const ModalContent = styled.div`
  position: relative;
  background: ${getColor("white")};
  border-radius: ${getBorderRadius(1.2)};
  padding: ${getSize(3.2)} ${getSize(2.8)};
  width: 100%;
  max-width: ${getSize(48)};
  margin: ${getSize(2)};
  display: flex;
  flex-direction: column;
  text-align: left;

  ${responsive("tablet")} {
    padding: ${getSize(4)} ${getSize(4)};
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${getSize(1.6)};
  margin-bottom: ${getSize(1.6)};
`;

export const CloseContainer = styled.div`
  position: absolute;
  top: ${getSize(1.2)};
  right: ${getSize(1.2)};
  cursor: pointer;
  padding: ${getSize(0.6)};
  color: ${getColor("textSecondary")};

  &:hover {
    color: ${getColor("text")};
  }
`;

export const IconCircle = styled.div`
  width: ${getSize(4.8)};
  height: ${getSize(4.8)};
  border-radius: 50%;
  background: ${getColor("errorLight")};
  color: ${getColor("error")};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Title = styled.h2`
  font-size: ${getSize(2)};
  font-weight: 700;
  color: ${getColor("text")};
  margin: 0;
`;

export const Description = styled.p`
  font-size: ${getSize(1.4)};
  font-weight: 400;
  color: ${getColor("secondary")};
  line-height: 1.5;
  margin: 0 0 ${getSize(2.8)};
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getSize(1.2)};
  width: 100%;

  ${responsive("tablet")} {
    flex-direction: row;
    justify-content: flex-end;
  }
`;
